import type { Infer } from 'superstruct';
import { object } from 'superstruct';

import { email } from '@adflow/shared/util-superstruct';

export const AddPasswordResetDto = object({
	email: email(),
});
export type AddPasswordResetDto = Infer<typeof AddPasswordResetDto>;
